import { forwardRef, useId } from 'react';
import { cn } from '../../lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, icon, id: idProp, ...props }, ref) => {
    const genId = useId();
    const id = idProp ?? (label ? genId : undefined);
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={id} className="block mb-1.5 text-xs font-medium text-ink-mid">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-mid pointer-events-none">
              {icon}
            </span>
          )}
          <input
            ref={ref}
            id={id}
            className={cn(
              'input-base',
              error && 'border-cyber-red focus:border-cyber-red',
              icon && 'pl-10',
              className,
            )}
            {...props}
          />
        </div>
        {error && (
          <p className="mt-1 text-xs text-cyber-red">{error}</p>
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';
